import {
  MoreVertical,
  Users,
  MapPin,
  Clock,
  DollarSign,
  Edit,
  Trash
} from 'lucide-react';

import ListOfferingRuleSetsForOfferingCard from '@/app/offeringSessionRuleSet/ListOfferingRuleSetsForOfferingCard';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from '@/components/ui/card';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from '@/components/ui/dropdown-menu';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';

const OfferingCard = ({ offering, onEdit, onDelete }) => {
  const {
    name,
    description,
    pricePerClient,
    length,
    isGroup,
    currency,
    location,
    status
  } = offering;

  const handleOnDelete = async () => {
    await onDelete(offering.id);
  };

  return (
    <Card className="w-full">
      <CardHeader className="p-4">
        <CardTitle className="flex items-center justify-between text-lg font-bold">
          <div className="flex items-center gap-2">
            {name}
            <Badge variant="outline">{status}</Badge>
          </div>
          {isGroup && <Users />}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm" className="w-8 p-0">
                <MoreVertical className="h-4 w-4" />
                <span className="sr-only">Open menu</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => onEdit(offering.id)}>
                <Edit />
                Edit
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                className="text-destructive"
                onClick={handleOnDelete}
              >
                <Trash />
                Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="px-4">
        <div className="grid grid-cols-2 text-sm mb-4">
          <div className="space-y-1">
            <div className="flex items-center space-x-2">
              <Clock className="w-4 h-4 text-muted-foreground" />
              <span>{length} minutes</span>
            </div>
            <div className="flex items-center space-x-2">
              <DollarSign className="w-4 h-4 text-muted-foreground" />
              <span>
                {(pricePerClient / 100).toFixed(2)} {currency}/ea
              </span>
            </div>
          </div>
          <div className="space-y-1">
            {location && (
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-muted-foreground" />
                <span>{location.name}</span>
              </div>
            )}
          </div>
        </div>
        <Separator className="my-4" />
        <h3 className="text-md font-medium mb-3">Availability</h3>
        <ListOfferingRuleSetsForOfferingCard offeringId={offering.id} />
      </CardContent>
    </Card>
  );
};

export default OfferingCard;
